import { useEffect, useState } from "react";
import api from "../../../services/api";

export const FetchStatus = {
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading"
};

export const useFetchFiles = () => {
  const [status, setStatus] = useState(FetchStatus.LOADING);
  const [data, setData] = useState(null);

  const fetchData = () => {
    api
      .get(`/contratos/planilha-conta-corrente/`)
      .then(({ data }) => {
        setData(data.reverse());
        setStatus(FetchStatus.SUCCESS);
      })
      .catch(err => {
        console.error(err);
        setStatus(FetchStatus.ERROR);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      console.log("Fetching xlsx list...");

      api.get(`/contratos/planilha-conta-corrente`).then(({ data }) => {
        setData(data.reverse());
      });
    }, [8000]); // 8 sec

    return () => {
      clearInterval(timer);
    };
  }, []);

  return {
    status,
    data,
    refresh: fetchData
  };
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/UploadContaCorrente/use-fetch-files.js